<template>
  <section class="menu-fitbar-section py-5 position-relative overflow-hidden" id="menu">
    <!-- Bowl Decorativo Flotante Disperso (Avena Imperial) -->
    <div class="floating-bowl-decor bowl-menu d-none d-lg-block">
      <img
        :src="require('@/assets/img/NEW Delivery_2.png')"
        alt="Avena Imperial"
        class="img-fluid floating-bowl-img"
      />
    </div>

    <!-- Resplandor decorativo de fondo -->
    <div class="menu-backdrop-glow"></div>

    <div class="container position-relative z-1">
      <!-- Encabezado de la Carta Gastronómica -->
      <div class="text-center mb-4">
        <h2 class="menu-main-title text-dark text-uppercase mt-2 mb-2">
          NUESTRO <span class="text-naranja">MENÚ FIT</span>
        </h2>
        <p class="quicksand lead text-muted mx-auto" style="max-width: 640px; font-size: 1.05rem;">
          Explora nuestros platillos preparados al momento. Ingredientes 100% frescos, porciones pesadas y balance nutricional para tu estilo de vida fitness.
        </p>
      </div>

      <!-- Selector de Categorías 100% Visible (Sin scroll horizontal) -->
      <div class="categories-no-scroll-wrapper mb-4">
        <div class="categories-grid-pills">
          <button
            v-for="cat in categorias"
            :key="cat.id"
            @click="seleccionarCategoria(cat.id)"
            type="button"
            class="btn btn-category-pill"
            :class="{ active: categoriaActiva === cat.id }"
          >
            <span class="cat-emoji">{{ cat.emoji }}</span>
            <span class="cat-name">{{ cat.nombre }}</span>
            <span class="cat-count">{{ contarPlatillos(cat.id) }}</span>
          </button>
        </div>
      </div>

      <!-- Contador de Resultados y Filtro Activo -->
      <div class="d-flex align-items-center justify-content-between mb-4 px-2">
        <div class="small text-muted fw-semibold">
          Mostrando <strong class="text-dark">{{ platillosFiltrados.length }}</strong> creaciones gastronómicas
        </div>
        <div v-if="categoriaActiva !== 'todos'">
          <button @click="limpiarFiltros" class="btn btn-link btn-sm text-naranja p-0 text-decoration-none fw-bold">
            <i class="bi bi-arrow-counterclockwise"></i> Ver todas las categorías
          </button>
        </div>
      </div>

      <!-- Grid Visual Food-Porn (Estilo Instagram / Pinterest Gastronómico) -->
      <div class="row g-4 justify-content-center">
        <div
          v-for="platillo in platillosFiltrados"
          :key="platillo.id"
          class="col-12 col-sm-6 col-lg-4"
        >
          <div
            class="food-porn-card rounded-4 overflow-hidden position-relative shadow-sm"
            @click="abrirModal(platillo)"
          >
            <!-- Imagen en Alta Resolución del Platillo -->
            <div class="food-img-wrapper">
              <img
                :src="platillo.foto"
                :alt="platillo.nombre"
                class="food-porn-img"
                loading="lazy"
              />
            </div>

            <!-- Overlay Gradiente Oscuro -->
            <div class="food-card-overlay"></div>

            <!-- Badge Superior (Antojo / Destacado) -->
            <div class="food-top-badges d-flex justify-content-between align-items-center">
            
              <span class="food-category-pill">
                {{ platillo.categoriaNombre }}
              </span>
            </div>

            <!-- Contenido Inferior Montado Sobre la Foto -->
            <div class="food-card-bottom p-3 p-md-4">
              <h4 class="food-card-title text-white mb-2">
                {{ platillo.nombre }}
              </h4>
              <div class="d-flex align-items-center justify-content-between gap-2 mt-2">
                <!-- Píldora de Macros Resumida -->
                <div class="macro-capsule-glass">
                  <span class="macro-text-bold text-naranja">{{ platillo.macros.proteina }} Pro</span>
                  <span class="macro-sep">·</span>
                  <span class="macro-text-light">{{ platillo.macros.calorias }}</span>
                </div>

                <!-- Botón Ver Receta -->
                <button class="btn-tap-detail" aria-label="Ver detalle del platillo">
                  <span>Ver detalle</span>
                  <i class="bi bi-arrow-up-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Banner de Personalización de Dieta -->
      
    </div>

    <!-- Modal Elegante de Platillo Ampliado (Food-Porn Modal) -->
    <transition name="modal-fade">
      <div
        v-if="platilloSeleccionado"
        class="modal-backdrop-custom d-flex align-items-center justify-content-center p-3"
        @click.self="cerrarModal"
      >
        <div class="modal-card-custom rounded-4 overflow-hidden shadow-2xl position-relative">
          <button class="btn-close-custom" @click="cerrarModal" aria-label="Cerrar modal">
            ✕
          </button>

          <div class="row g-0">
            <!-- Columna Izquierda: Fotografía Grande -->
            <div class="col-12 col-md-6 modal-img-col position-relative">
              <img
                :src="platilloSeleccionado.foto"
                :alt="platilloSeleccionado.nombre"
                class="w-100 h-100 modal-img"
              />
              <div class="modal-badge-float" :class="'badge-' + platilloSeleccionado.badgeType">
                {{ platilloSeleccionado.badge }}
              </div>
            </div>

            <!-- Columna Derecha: Información Nutricional & Botón Directo -->
            <div class="col-12 col-md-6 p-4 p-lg-5 d-flex flex-column justify-content-between">
              <div>
                <span class="badge-modal-cat text-uppercase fw-bold mb-2 d-inline-block">
                  {{ platilloSeleccionado.categoriaNombre }}
                </span>
                <h3 class="modal-dish-title text-dark mb-3">
                  {{ platilloSeleccionado.nombre }}
                </h3>

                <p class="quicksand text-muted mb-4 fs-6" style="line-height: 1.6;">
                  {{ platilloSeleccionado.descripcion }}
                </p>

                <!-- Cuadrícula Elegante de Macronutrientes -->
                <div class="macros-grid p-3 rounded-3 mb-4">
                  <div class="macro-cell">
                    <span class="macro-label">PROTEÍNA</span>
                    <span class="macro-val fs-5 text-naranja fw-bold">{{ platilloSeleccionado.macros.proteina }}</span>
                  </div>
                  <div class="macro-cell">
                    <span class="macro-label">CARBOHIDRATOS</span>
                    <span class="macro-val fs-5 fw-bold text-dark">{{ platilloSeleccionado.macros.carbos }}</span>
                  </div>
                  <div class="macro-cell">
                    <span class="macro-label">GRASAS</span>
                    <span class="macro-val fs-5 fw-bold text-dark">{{ platilloSeleccionado.macros.grasas }}</span>
                  </div>
                  <div class="macro-cell">
                    <span class="macro-label">CALORÍAS</span>
                    <span class="macro-val fs-5 fw-bold text-dark">{{ platilloSeleccionado.macros.calorias }}</span>
                  </div>
                </div>
              </div>

              <!-- Botón Directo a WhatsApp -->
              <div class="mt-3">
                <a
                  :href="getWhatsappUrl(platilloSeleccionado)"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="btn btn-order-modal w-100 py-3 rounded-pill text-decoration-none fw-bold text-center d-flex align-items-center justify-content-center gap-2"
                >
                  <i class="bi bi-whatsapp fs-5"></i>
                  <span>Pedir por WhatsApp (998 364 1651)</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import { mapState } from "vuex";
import { getPlatilloWhatsappUrl } from "@/data/platillos.js";

export default {
  name: "Menu_fitbar",
  data() {
    return {
      categoriaActiva: "hotcakes",
      platilloSeleccionado: null,
    };
  },
  computed: {
    ...mapState(["platillos", "categorias"]),
    platillosFiltrados() {
      let lista = this.platillos || [];
      if (this.categoriaActiva !== "todos") {
        lista = lista.filter((p) => p.categoriaId === this.categoriaActiva);
      }
      return lista;
    },
  },
  methods: {
    seleccionarCategoria(catId) {
      this.categoriaActiva = catId;
    },
    limpiarFiltros() {
      this.categoriaActiva = "todos";
    },
    contarPlatillos(catId) {
      if (!this.platillos) return 0;
      if (catId === "todos") return this.platillos.length;
      return this.platillos.filter((p) => p.categoriaId === catId).length;
    },
    getWhatsappUrl(platillo) {
      return getPlatilloWhatsappUrl(platillo);
    },
    abrirModal(platillo) {
      this.platilloSeleccionado = platillo;
      document.body.style.overflow = "hidden";
    },
    cerrarModal() {
      this.platilloSeleccionado = null;
      document.body.style.overflow = "auto";
    },
  },
};
</script>

<style scoped>
.menu-fitbar-section {
      background-color: rgb(126 126 126 / 23%);
}

.text-naranja {
  color: #fd6f3c !important;
}

.menu-backdrop-glow {
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  width: 700px;
  height: 400px;
  background: radial-gradient(circle, rgba(253, 111, 60, 0.08) 0%, rgba(250, 249, 248, 0) 70%);
  border-radius: 50%;
  pointer-events: none;
}

.menu-section-pill {
  background: #ffffff;
  border: 1px solid rgba(253, 111, 60, 0.3);
  padding: 5px 18px;
  border-radius: 50px;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.8px;
  color: #333333;
  box-shadow: 0 2px 10px rgba(253, 111, 60, 0.08);
}

.menu-main-title {
  font-family: 'Montserrat', sans-serif;
  font-weight: 900;
  font-size: clamp(1.8rem, 3.5vw, 2.6rem);
  letter-spacing: -0.01em;
}

/* Pestañas de Categorías (Pills Centrados sin scroll horizontal) */
.categories-no-scroll-wrapper {
  max-width: 1080px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 0.5rem;
}

.categories-grid-pills {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.btn-category-pill {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.09);
  padding: 8px 18px;
  border-radius: 50px;
  font-size: 0.88rem;
  font-weight: 700;
  color: #444444;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);
}

.btn-category-pill:hover {
  border-color: #fd6f3c;
  color: #fd6f3c;
  transform: translateY(-2px);
}

.btn-category-pill.active {
  background: linear-gradient(135deg, #fd6f3c 0%, #ff5214 100%);
  color: #ffffff;
  border-color: transparent;
  box-shadow: 0 6px 18px rgba(253, 111, 60, 0.35);
  transform: translateY(-2px);
}

.cat-emoji {
  font-size: 1.15rem;
}

.cat-count {
  background: rgba(0, 0, 0, 0.08);
  padding: 2px 7px;
  border-radius: 20px;
  font-size: 0.72rem;
  font-weight: 800;
}

.btn-category-pill.active .cat-count {
  background: rgba(255, 255, 255, 0.25);
  color: #ffffff;
}

/* ====================================================================
   Tarjetas Visuales Food-Porn (Pinterest / Instagram Showcase)
   ==================================================================== */
.food-porn-card {
  height: 360px;
  cursor: pointer;
  background-color: #1a1a1a;
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.food-porn-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25) !important;
  border-color: rgba(253, 111, 60, 0.4);
}

.food-img-wrapper {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.food-porn-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

.food-porn-card:hover .food-porn-img {
  transform: scale(1.08);
}

.food-card-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(0, 0, 0, 0.05) 40%,
    rgba(0, 0, 0, 0.82) 80%,
    rgba(0, 0, 0, 0.95) 100%
  );
  z-index: 1;
  transition: opacity 0.3s ease;
}

.food-top-badges {
  position: absolute;
  top: 14px;
  left: 14px;
  right: 14px;
  z-index: 2;
}

.food-badge-pill {
  padding: 5px 12px;
  border-radius: 30px;
  font-size: 0.74rem;
  font-weight: 800;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.badge-fire {
  background: linear-gradient(135deg, #fd6f3c 0%, #ff2a00 100%);
}

.badge-gourmet {
  background: linear-gradient(135deg, #d4af37 0%, #aa8012 100%);
}

.badge-protein {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.badge-fresh {
  background: linear-gradient(135deg, #06b6d4 0%, #0284c7 100%);
}

.badge-favorite {
  background: linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%);
}

.food-category-pill {
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 30px;
  border: 1px solid rgba(255, 255, 255, 0.15);
}

.food-card-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
}

.food-card-title {
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 1.25rem;
  line-height: 1.3;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.6);
}

.macro-capsule-glass {
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50px;
  padding: 5px 12px;
  font-size: 0.78rem;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.macro-text-bold {
  font-weight: 800;
}

.macro-sep {
  opacity: 0.5;
}

.macro-text-light {
  font-weight: 600;
  opacity: 0.9;
}

.btn-tap-detail {
  background: rgba(255, 255, 255, 0.95);
  color: #1a1a1a;
  border: none;
  border-radius: 50px;
  padding: 6px 14px;
  font-size: 0.78rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: all 0.25s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.food-porn-card:hover .btn-tap-detail {
  background: #fd6f3c;
  color: #ffffff;
  transform: scale(1.05);
}

/* Banner de personalización */
.banner-custom-order {
  background: #ffffff;
  border: 1px solid rgba(253, 111, 60, 0.2);
}

.btn-naranja-custom {
  background-color: #fd6f3c;
  color: #ffffff;
  transition: all 0.3s ease;
}

.btn-naranja-custom:hover {
  background-color: #e55928;
  color: #ffffff;
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(253, 111, 60, 0.35);
}

/* ====================================================================
   Modal Elegante Gastronómico
   ==================================================================== */
.modal-backdrop-custom {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  z-index: 9999;
}

.modal-card-custom {
  background: #ffffff;
  max-width: 860px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.btn-close-custom {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.7);
  color: #ffffff;
  border: none;
  font-weight: 900;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  cursor: pointer;
  transition: background 0.2s ease;
}

.btn-close-custom:hover {
  background: #fd6f3c;
}

.modal-img-col {
  min-height: 340px;
  background: #111;
}

.modal-img {
  object-fit: cover;
}

.modal-badge-float {
  position: absolute;
  top: 16px;
  left: 16px;
  padding: 6px 14px;
  border-radius: 30px;
  font-size: 0.8rem;
  font-weight: 800;
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.badge-modal-cat {
  background: rgba(253, 111, 60, 0.12);
  color: #fd6f3c;
  padding: 4px 12px;
  border-radius: 30px;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
}

.modal-dish-title {
  font-family: 'Montserrat', sans-serif;
  font-weight: 900;
  font-size: 1.8rem;
  line-height: 1.25;
}

.macros-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  background: #f8f7f5;
  border: 1px solid rgba(0, 0, 0, 0.06);
  text-align: center;
}

.macro-cell {
  display: flex;
  flex-direction: column;
  padding: 4px 6px;
}

.macro-cell:not(:last-child) {
  border-right: 1px solid rgba(0, 0, 0, 0.06);
}

.macro-label {
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.5px;
  color: #888888;
  margin-bottom: 2px;
}

.macro-val {
  font-family: 'Montserrat', sans-serif;
}

.btn-order-modal {
  background-color: #25d366;
  color: #ffffff;
  font-size: 1rem;
  box-shadow: 0 6px 20px rgba(37, 211, 102, 0.35);
  transition: all 0.25s ease;
}

.btn-order-modal:hover {
  background-color: #1eb956;
  color: #ffffff;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(37, 211, 102, 0.5);
}

/* Animaciones del Modal */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .categories-grid-pills {
    gap: 8px;
  }
  .btn-category-pill {
    padding: 6px 13px;
    font-size: 0.8rem;
    gap: 6px;
  }
  .cat-emoji {
    font-size: 1rem;
  }
  .food-porn-card {
    height: 320px;
  }
  .modal-img-col {
    min-height: 240px;
  }
}

/* Bowl Decorativo Flotante Disperso (Avena Imperial) */
.floating-bowl-decor {
  position: absolute;
  z-index: 5;
  pointer-events: none;
  filter: drop-shadow(0 15px 25px rgba(0, 0, 0, 0.18));
}

.bowl-menu {
  top: 25px;
  left: clamp(20px, 5vw, 100px);
  animation: floatBowlMenu 6s ease-in-out infinite alternate;
}

.floating-bowl-img {
  width: 215px;
  height: 215px;
  object-fit: contain;
  transform: rotate(-8deg);
  transition: transform 0.3s ease;
}

.bowl-label-mini {
  background: rgba(20, 24, 26, 0.88);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(253, 111, 60, 0.4);
  color: #fff;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 3px 12px;
  border-radius: 20px;
  text-align: center;
  margin-top: -8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  white-space: nowrap;
}

@keyframes floatBowlMenu {
  0% { transform: translateY(0) rotate(0deg); }
  100% { transform: translateY(-15px) rotate(-4deg); }
}
</style>
